import React from 'react';
import { colors } from 'styleguide';

interface FourProps {
  width?: number;
  height?: number;
  color?: {
    primrary: string;
    secondary: string;
  };
}

const Four = ({
  width = 65,
  color = { primrary: '#9498A7', secondary: colors('neutral', 3) },
}: FourProps) => (
  <svg width={width} viewBox="0 0 65 30" fill="none">
    <rect
      x="51.5"
      y="0.5"
      width="13"
      height="29"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="17.5"
      y="0.5"
      width="13"
      height="29"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="34.5"
      y="0.5"
      width="13"
      height="29"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="0.5"
      y="0.5"
      width="13"
      height="29"
      rx="1.5"
      stroke={color.primrary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
  </svg>
);

export default Four;
